import type { FC, SVGProps } from "react";

const VolumeMedium: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="volume medium icon">
      {/* <title>volume medium icon</title> */}
      <path
        d="M15.3678 9.21939C15.0098 8.92883 14.4829 8.97999 14.1925 9.338C13.8998 9.69493 13.952 10.2214 14.3101 10.5143C14.7027 10.8386 14.929 11.3053 14.929 11.7997C14.929 12.2939 14.7027 12.7615 14.3088 13.0837C13.9509 13.3764 13.8986 13.903 14.1913 14.26C14.3556 14.4623 14.5959 14.5668 14.8376 14.5668C15.0237 14.5668 15.212 14.5048 15.3666 14.3786C16.1513 13.7359 16.6005 12.7992 16.6005 11.7997C16.6005 10.8003 16.1513 9.86361 15.3678 9.21939ZM17.4746 6.646C17.1187 6.35545 16.5922 6.40552 16.2982 6.76245C16.0055 7.11938 16.0578 7.6459 16.4147 7.93876C17.5964 8.90599 18.272 10.3128 18.272 11.7997C18.272 13.2867 17.595 14.6932 16.4156 15.6616C16.0587 15.9543 16.0064 16.4809 16.2992 16.8379C16.4646 17.0392 16.7038 17.1437 16.9455 17.1437C17.1326 17.1437 17.3198 17.0816 17.4755 16.9543C19.0451 15.6685 19.9435 13.7881 19.9435 11.7997C19.9435 9.81138 19.0451 7.93096 17.4746 6.646ZM11.4886 4.09839C11.0881 3.91776 10.6176 3.98988 10.2896 4.28152L5.58961 8.45678H2.67148C1.74834 8.45678 1 9.20512 1 10.0969L1 13.4085C1 14.3317 1.74834 15.0487 2.67148 15.0487H5.59101L10.2886 19.2239C10.4961 19.5025 10.7608 19.6 11.0289 19.6C11.1834 19.6 11.3409 19.5676 11.4872 19.5012C11.889 19.3214 12.1432 18.9244 12.1432 18.4857L12.1432 5.11381C12.1432 4.6754 11.889 4.24673 11.4886 4.09839Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default VolumeMedium;
